/** Период оборота static.png (пила), сек. Слегка разный у соседних, чтобы не синхронизировались. */
const FACTOR_STATIC_SPIN_DURATIONS_SEC = [3.2, 3.6, 4.0, 4.4] as const;

export function factorStaticSpinDurationSec(index: number): number {
  return FACTOR_STATIC_SPIN_DURATIONS_SEC[index % FACTOR_STATIC_SPIN_DURATIONS_SEC.length];
}
